import { sentinelModule } from "../modules/sentinelModule";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {mainMenu_template} from "../components/templates/mainMenu_template";

import {appTitle_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/appTitle_template";

declare var ko: any;
declare var page: any;

export class menu_mod extends sentinelModule{

    protected XHRHdl: XMLHttpRequestHandler;
    protected mainMenu_template: mainMenu_template;

    protected getModuleName(){
        return "w-main-nav";
    }

    buildContent() : Array<Element>{

        const parentContent = super.buildContent();

        // Create the logo and the title
        let appTitle = new appTitle_template("appTitle", this.viewModel, this);
        appTitle.setTitle("sentinelpro");
        appTitle.setHomeLinkMethod("assign");

        this.mainMenu_template = new mainMenu_template("mainMenu", this.viewModel, this);

        appTitle.setUrl('/');
        return [...parentContent, appTitle.build(), this.mainMenu_template.build()];
    }

    public fillPage() : void{

        let vnApp = this.getVnAppZone().app;

        if(vnApp.loggedUser.isLoggedIn) {
            this.getListData();
        }

    }

    public getListData(): void{

        this.mainMenu_template.activateLoading();

        let usrReq_url: string = '/api/menu/list_data';
        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON({device:this.getVnAppZone().getCookie('device'), deviceView:this.getVnAppZone().getCookie('deviceView')})] );
        

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed.menuItems);
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.mainMenu_template.deactivateLoading();
            }
        };
    }

    protected updateList(menuItems: any){
        this.mainMenu_template.setMenus(menuItems);
    }

    public getGlobalSelectedBrandMenuPage(id) {
        return '';
    }

    public getActiveMenus() {
        return [];
    }

    public setGlobalSelectedBrandMenuPage(id) {}

    public resetGlobalSelectedBrandMenuPage(): void {}

    public handleActiveMenus(): void {}

    public getDefaultSectionId() {
        return '';
    }

    public setDefaultSectionId(sectionId): void {}
    
}


// WEBPACK FOOTER //
// ./js/modules/menu.ts